import axios from "axios";
import { proxyUrl } from "../config";
import { setupInterceptorsTo } from "./Interceptors";
setupInterceptorsTo(axios);

export interface DocPreLogs
{
    id?: number,
    userId: number,
    isin: string,
    documentType: string,
    dateClick: string,
    createdAt?: string,
    updatedAt?: string
};

export const requiredPreLogGroups = [
    ['000011'],
    ['000018', '000008', '000012'],
    ['000010', '000009', '000014', '000020']
];

export function checkAllDocsIncluded(isin: string, documents: any[]) {
    let selectedDocuments: any[] = [];

    let groups = [...requiredPreLogGroups];

    if (isin.startsWith('ES')) {
        groups.shift();
    }

    for (let i = 0; i < groups.length; i++) {
        let doc = documents.find((d: any) => d.type === groups[i][0]);

        if (!doc) {
            doc = documents.find((d: any) => groups[i].includes(d.type));
        }

        if (doc) {
            selectedDocuments.push(doc);
        }
    }

    return {
        result: selectedDocuments.length > 0, // selectedDocuments.length === (isin.startsWith('ES') ? 2 : 3),
        documents: selectedDocuments
    };
}

class DocPreLogService
{
    public docPreLogsByUserId = async (userId: number, isins: string[]): Promise<DocPreLogs[]> =>
    {
        let url: string = `${proxyUrl}/docPreLogs/getByUserId/${userId}`
        const req = await axios.get(url, { params: { isins: isins } });
        return req.data;
    }

    public createDocPreLogs = async (docPreLogs: DocPreLogs): Promise<DocPreLogs> =>
    {
        let url: string = `${proxyUrl}/docPreLogs`
        const req = await axios.post(url, docPreLogs);
        return req.data;
    }
}

const docPreLogs = new DocPreLogService();
export default docPreLogs;